export default "__VITE_PUBLIC_ASSET__56bc7602__"